import React from 'react';
import ListDropdown from '../Dropdowns/List/ListDropdown';
import Props, {OptionsProps} from './typings';

const Sort = ({selected, dropdownPosition, callback}: Props) => {
  const sortingOptions: Readonly<OptionsProps[]> = [
    {
      label: 'Best match',
      key: 'best_match',
    },
    {
      label: 'New',
      key: 'newest',
    },
    {
      label: 'Price low to high',
      key: 'price_asc',
    },
    {
      label: 'Price high to low',
      key: 'price_desc',
    },
  ];

  const optionChanged = (key) => {
    callback(key);
  };

  return (
    <ListDropdown
      options={sortingOptions}
      type="inline"
      title={
        selected
          ? sortingOptions.find((option) => option.key === selected)?.label ?? 'Sort'
          : sortingOptions?.[0]?.label ?? 'Sort'
      }
      dropdownPosition={dropdownPosition}
      callback={optionChanged}
      selected={selected ?? sortingOptions[0].key}
    />
  );
};

export default Sort;
